import styled from 'styled-components';
import * as RubikMedium from '../fonts/Rubik-Medium.ttf';

export const DirectionBtnContainer = styled.div`
  width: 200px;
  height: 200px;
  position: absolute;
  bottom: 0px;
  right: 30px;
`

export const TBContainer = styled.div`
  width: 700px;
  line-height: 2.5;
  border: solid 1px #bdbdbd;
  border-radius: 6px;
  margin-left: 4px;
  padding: 8px 12px;
  font-size: 16px;
  font-family: 'Rubik', sans-serif;

`

export const SummaryContainer = styled(TBContainer)`
  margin-left: 24px;
`

export const Taggedem = styled.span`
  background: clear;
  border-radius: 16px;
  /* padding: 0px 0px; */
  cursor: default;
  color: white;
  font-family: 'Rubik', sans-serif;
  font-weight: bold;
  font-size: 16px;
`
// linear-gradient(to right, rgba(24,112,57,0.86), rgba(162,210,81,0.83));
export const Tag = styled.div`
  background: #0d47a1;
  display: inline-block;
  width: auto;
  height: 2em;
  border-radius: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 0px;
  /* padding-bottom: 25px; */
  color: white;
  font-family: ' Andale Mono';
  font-weight: bold;
  cursor: default;
  font-size: 16px;
`

export const SentiTag = styled(Tag)`
  background: ${props=> props.styled.color_tag };
`

export const Aspan = styled.span`
  // color: #616161;
  cursor: default;
`

export const AspanSenti = styled.em`
  cursor: default;
`



// border-bottom: ${props => props.styled.type === "opinion" ? "solid" : null};
// border-color: ${props => props.styled.code};
// border: ${props => props.styled.type === "aspect" ? "solid" : null }
//
//
//
// border-bottom-color: ${props => ( props.styled.type === "aspect") ? 'yellow'  : null }
//
// background: ${props => (props.styled.type === "opinion") ? "yellow" : null }
